export interface Group {
  id?: string;
  level?: number;
  value: any;
  name: string;
  isActive?: boolean;
  inactiveLabel?: string;
}
